import featureTest from './featureTest';

export default () => featureTest('touch-action', 'none');
